import { SetLoader } from '../../redux/actions/loader'
import { GET, POST, DELETE, PUT } from '../API'
import { store } from '../../redux/store'
const { dispatch } = store

export {
  GetPaginationFacilityList,
  GetCustomerFacilities,
  GetCustomerInfo,
  DeleteCustomer,
  saveFacility,
  GetSFDFacilityTemplate,
  changeCustomerStatus,
  GetPaginationCustomersListWithSearch,
  ASSET_STATUS_ENUM,
}

const ASSET_STATUS_ENUM = {
  REGISTERED: 'REGISTERED',
  CONFIGURED: 'CONFIGURED',
  PROVISIONED: 'PROVISIONED',
  ACTIVE: 'ACTIVE',
  ALL: 'ALL',
}
// localhost:9999/spectro/customers/search?product=cold&title=sh&page=0&size=10&status=Active
const GetPaginationCustomersListWithSearch = async (
  productName,
  customerID,
  title,
  currentPage,
  size,
  status,
) => {
  const queryParams = {
    product: productName,
    customerId: customerID,
    title,
    page: currentPage,
    size,
    status,
  }
  dispatch(SetLoader(true))

  const response = await GET(`/spectro/customers/search/`, queryParams)
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

// localhost:9999/spectro/customers/aa@spectro.net?product=cold&page=0&size=5
// spectro/assets/customer/aa@spectro.net?type=Facility&product=cold&page=0&size=10
const GetPaginationFacilityList = async (
  userEmail,
  productName,
  customer,
  currentPage,
  size,
) => {
  const queryParams = {
    type: 'Facility',
    product: productName,
    customerId: customer,
    page: currentPage,
    size,
  }
  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/assets/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

// localhost:9999/spectro/facilities/templates/SFDA?product=cold
const GetSFDFacilityTemplate = async (facilityType, productName) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }
  const response = await GET(
    `/spectro/facilities/templates/${facilityType}`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}
// spectro/customers/aa@spectro.net?product=cold
// get user customers
// localhost:9999/spectro/assets/customer/aa@spectro.net?type=Facility&product=cold
const GetCustomerFacilities = async (userEmail, productName) => {
  const queryParams = {
    type: 'Facility',
    product: productName,
  }
  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/assets/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}
// http://localhost:9999/spectro/users/{user title}?product=cold

const DeleteCustomer = async (customerTile, productName) => {
  console.log('productName', productName)
  console.log('customerTile', customerTile)
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join('&')
  const response = await DELETE(`/spectro/users/${customerTile}`, queryString)
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  return {}
}

// localhost:9999/spectro/customers/aa@spectro.net/SH_Co2
const GetCustomerInfo = async (userEmail, title) => {
  dispatch(SetLoader(true))
  const queryParams = {}
  const response = await GET(
    `/spectro/customers/${userEmail}/${title}`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}

// localhost:9999/spectro/facilities/customer/SFDA/aa@spectro.net/test3?product=cold
const saveFacility = async (
  productName,
  email,
  bodyData,
  facilityType,
  customer,
  customerTitle,
  tenant,
  coordinates,
) => {
  console.log('customer', `${customer}`)
  console.log('bodyData', bodyData)
  dispatch(SetLoader(true))
  const queryParams = {
    title: customerTitle,
    customerId: customer,
    tenantId: tenant,
    product: productName,
    fromId: bodyData.region,
    fromType: 'region',
  }
  let body = {}
  let response = ''
  if (facilityType === 'DEFAULT') {
    // spectro/facilities/aa@spectro.net/test3?product=cold
    body = {
      name: bodyData.Name,
      latitude: bodyData.Latitude,
      longitude: bodyData.Longitude,
    }
    response = await POST(`/spectro/facilities/`, queryParams, body)
    dispatch(SetLoader(false))
  } else {
    body = {
      name: bodyData.Name,
      city: bodyData.City,
      address: bodyData.Address,
      latitude: bodyData.Latitude,
      longitude: bodyData.Longitude,
      'license number': bodyData['License Number'],
      'license issue date': bodyData['License Issue Date'],
      'license expiry date': bodyData['License Expiry Date'],
      phone: bodyData.Phone,
      'manager mobile': bodyData['Manager Mobile'],
      email: bodyData.email,
      'land area in square meter': bodyData['Land Area In Square Meter'],
      'land coordinates': coordinates,
    }
    response = await POST(`/spectro/facilities/`, queryParams, body)
    dispatch(SetLoader(false))
  }
  return response
}
// http://localhost:9999/spectro/customers/SH_Co2/change-status?product=cold&status=Inactive
const changeCustomerStatus = async (productName, title) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }

  const response = await PUT(
    `/spectro/customers/${title}/change-status`,
    queryParams,
  )
  dispatch(SetLoader(false))
  return response
}
